import { useEffect } from 'react';

const BASE = 'Meio Ambiente — Duas Barras';

export default function useTitulo(titulo) {
    useEffect(() => {
        document.title = titulo ? `${titulo} | ${BASE}` : BASE;
    }, [titulo]);
}
